export default class confirmationController {
  constructor($stateParams, Confirmation, Auth) {
    'ngInject';

    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.Confirmation = Confirmation;
    this.errors = [];
  }

  $onInit() {
    this.Auth.logout()
      .then(() => {
        return this.Confirmation.sendRequest(this.$stateParams);
      })
      .then((response) => {
        this.confirmed = true;
      })
      .catch((response) => {
        this.errors = response.data.errors;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/confirmation/confirmation.controller.js